// Labour & parts write straight onto the live work order (queued only while there's no signal)
import { queue, uid } from "./techData";

const key = (cid) => `tc:/tech/client/${cid}/workorders`;
const read = (cid) => JSON.parse(localStorage.getItem(key(cid)) || "[]");
const same = (l, it) => l.kind === it.kind && (it.kind === "part" ? l.product_id === it.product_id || (!!it.item && l.item === it.item) : (l.item || "").trim().toLowerCase() === it.item.trim().toLowerCase());

export const woOf = (cid, wid) => read(cid).find((w) => w.id === wid);
export const woQty = (cid, wid, it) => (woOf(cid, wid)?.lines || []).filter((l) => same(l, it)).reduce((a, l) => a + Number(l.qty || 0), 0);

// it = { kind: "part"|"labour", product_id, item, unit }
export function bumpWo(cid, wid, it, d) {
  const ref = uid();
  queue(`bump:${ref}`, "POST", `/tech/workorder/${wid}/bump`, { ref, delta: d, kind: it.kind, product_id: it.product_id, name: it.item, price: it.unit, description: it.item });
  const next = read(cid).map((w) => {
    if (w.id !== wid) return w;
    const wl = [...(w.lines || [])];
    let i = -1;
    wl.forEach((l, n) => { if (same(l, it)) i = n; });
    if (i < 0 && d > 0) wl.push({ kind: it.kind, item: it.item, product_id: it.product_id, unit: it.unit || 0, qty: d, discount: 0, net: (it.unit || 0) * d, from_tech_app: true });
    else if (i >= 0) {
      const q = Math.round((Number(wl[i].qty || 0) + d) * 100) / 100;
      if (q <= 0) wl.splice(i, 1);
      else wl[i] = { ...wl[i], qty: q, net: q * (wl[i].unit || 0) - (wl[i].discount || 0) };
    }
    return { ...w, lines: wl, total: wl.reduce((a, l) => a + (l.net || 0), 0) };
  });
  localStorage.setItem(key(cid), JSON.stringify(next));
  window.dispatchEvent(new Event("tech:wo"));
}
